<script>
export default {
  name: "defaultEmailTemplates",
  data() {
    return {
      templates: [],
      defaultProofEmailTemplateId: null,
      defaultNewVersionEmailTemplateId: null,
      loading: true,
    };
  },
  async mounted() {
    await this.loadData();
    this.$root.$on("email::template::saved", this.loadTemplates);
  },
  methods: {
    loadData: async function () {
      this.loading = true;
      await this.loadTemplates();
      this.defaultProofEmailTemplateId = _.get(this, '$A.Auth.account.defaultProofEmailTemplateId', null);
      this.defaultNewVersionEmailTemplateId = _.get(this, '$A.Auth.account.defaultNewVersionEmailTemplateId', null);
      this.loading = false;
    },
    loadTemplates: async function () {
      this.templates = await this.$A.TemplateService.GetAll();
    },
    saveDefaultTemplates: async function () {
      let account = await this.$A.AccountService.UpdateDefaultEmailTemplates(
          this.defaultProofEmailTemplateId,
          this.defaultNewVersionEmailTemplateId
      );
      if (account) {
        this.$A.Auth.account = account;
        this.$A.SaveSessionData(this.$A.Auth);
      }
    },
    getTemplateName: function (templateId) {
      if (!templateId) return "None";
      const template = this.templates.find(t => t.id === templateId);
      return template ? template.name : "Template not found";
    },
    isTemplateValid: function (templateId) {
      if (!templateId) return true;
      return this.templates.some(t => t.id === templateId);
    }
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Default Email Templates</div>
      <div class="card-head-subtitle">Set default email templates to be pre-selected when creating new proofs or new versions.</div>
    </div>
    <div class="card-body">
      <div class="field">
        <label class="field-label">Default email template for new proofs</label>
        <p class="field-help">This template will be pre-selected when creating new proofs.</p>
        <v-select
            v-model="defaultProofEmailTemplateId"
            :options="templates"
            label="name"
            :reduce="template => template.id"
            placeholder="None"
            class="template-select"
            :clearable="true"
            :loading="loading"
        >
          <template #no-options>
            No email templates available
          </template>
        </v-select>
        <p v-if="defaultProofEmailTemplateId && !isTemplateValid(defaultProofEmailTemplateId)"
           class="warning-text">
          The previously selected template no longer exists
        </p>
      </div>
      <div class="field">
        <label class="field-label">Default email template for new versions</label>
        <p class="field-help">This template will be pre-selected when creating new versions.</p>
        <v-select
            v-model="defaultNewVersionEmailTemplateId"
            :options="templates"
            label="name"
            :reduce="template => template.id"
            placeholder="None"
            class="template-select"
            :clearable="true"
            :loading="loading"
        >
          <template #no-options>
            No email templates available
          </template>
        </v-select>
        <p v-if="defaultNewVersionEmailTemplateId && !isTemplateValid(defaultNewVersionEmailTemplateId)"
           class="warning-text">
          The previously selected template no longer exists
        </p>
      </div>
    </div>
    <div class="card-foot">
      <a class="primary-btn" @click="saveDefaultTemplates">Save</a>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 2px;
}
.field-help {
  margin: 0 0 8px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.5;
}
.warning-text {
  margin: 6px 0 0;
  font-size: 12px;
  font-weight: 500;
  color: #b43643;
}
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.template-select {
  max-width: 420px;
}
.template-select ::v-deep .vs__dropdown-toggle {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 8px;
  height: 38px;
  background: white;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
}
.template-select ::v-deep .vs__dropdown-menu {
  font-weight: 400 !important;
  font-size: 13px;
}
.template-select ::v-deep .vs__search,
.template-select ::v-deep .vs__search:focus {
  margin: 0 !important;
  padding: 0 !important;
}
.template-select ::v-deep .vs__selected {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 13px;
  color: #1f2937;
}
@media (max-width: 575px) {
  .primary-btn {
    width: 100%;
  }
}
</style>
